import React, { useState, useEffect } from "react";
import { createAppKit } from "@reown/appkit/react";
import { WagmiProvider, useAccount, useDisconnect } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"; // ✅ Import QueryClientProvider
import {
  mainnet,
  arbitrum,
  base,
  scroll,
  bsc,
  polygon,
  defineChain,
} from "@reown/appkit/networks";

import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { useDispatch, useSelector } from "react-redux";
import { setaccount } from "../Redux/Accounts";
import { setDisConnectWallet } from "../Redux/StatusState";

// 1. Get projectId from https://cloud.reown.com
const projectId = "13db330e5ce1624533558566b8ba1de9";
const queryClient = new QueryClient();
// 2. Define BSC Testnet **before** using it
const bscTestnet = defineChain({
  id: 56,
  caipNetworkId: "eip155:97",
  chainNamespace: "eip155",
  name: "BSC Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "Binance Coin",
    symbol: "tBNB",
  },
  rpcUrls: {
    default: {
      http: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
      webSocket: ["wss://data-seed-prebsc-1-s1.binance.org:8545/"],
    },
  },
  blockExplorers: {
    default: { name: "BscScan", url: "https://bscscan.com" },
  },
});

// 3. Set the networks
const networks = [bscTestnet, bsc, mainnet, arbitrum, base, scroll, polygon];
// const networks = [bscTestnet];

// 4. Create Wagmi Adapter
const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: true,
});

// 5. Create modal
createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  features: {
    analytics: true,
    email: false,
    socials: false,
  },
  themeVariables: {
    "--wui-color-accent-base-100": "#b8810d", // Change button background color
    "--wui-color-fg-on-accent": "#000000", // Change button text color
    "--wui-connect-button-text": "#000000", // Ensure button text is white
    "--w3m-accent": "#b8810d", // Change Wallet Modal accent color
  },
});

export function AppKitProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {" "}
      {/* ✅ Wrap with QueryClientProvider */}
      <WagmiProvider config={wagmiAdapter.wagmiConfig}>
        <WalletProvider>{children}</WalletProvider>
      </WagmiProvider>
    </QueryClientProvider>
  );
}

function WalletProvider({ children }) {
  const dispatch = useDispatch();
  const { address, isConnected, isConnecting } = useAccount(); // Get wallet info
  const { disconnect } = useDisconnect();

  const disConnectWallet = useSelector(
    (state) => state.userStatus.disConnectWallet
  );

  const handleLogout = async () => {
    console.log("Attempting to disconnect...");
    try {
      disconnect();
      dispatch(setaccount(null));
      console.log("Wallet disconnected successfully.");
    } catch (error) {
      console.error("Error disconnecting wallet:", error);
    }
  };

  useEffect(() => {
    if (disConnectWallet == true) {
      handleLogout();
      dispatch(setDisConnectWallet(false));
    }
  }, [disConnectWallet]);

  useEffect(() => {
    dispatch(setaccount(isConnected ? address : null));
    console.log("isConnected", isConnected);
  }, [address, isConnected, dispatch]);

  return isConnecting ? (
    <p>Connecting...</p>
  ) : (
    <div id="connectBtnDiv" className={isConnected && "connectBtnDivShadow"}>
      <appkit-button balance={false} />{" "}
    </div>
  );
}
